import { AbstractRoomModel } from "@app/catalog-common";


export class SelectRoomMessage {
  selected: AbstractRoomModel;

  constructor(selected: AbstractRoomModel) {
    if(selected != undefined){
        this.selected =  selected;
    }
  }
}